
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Link from 'components/Link'
import SlideContainer from 'components/SlideContainer'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {connect} from 'react-redux'

export class IntegrationUploadView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer
        className='integration-upload-view'
        width={720}
      >
        <div className='integration-upload-view_container'>
          {this.renderInfo()}
          <div className='integration-upload-view_main-column'>
            {this.renderHeader()}
            {this.renderContent()}
            <Icon
              className='integration-upload-view_close-icon'
              name='cross'
              size='25px'
              onClick={closeModal}
            />
          </div>
        </div>
      </SlideContainer>
    )
  }

  renderInfo() {
    return (
      <div className='integration-upload-view_info'>
        <div className='integration-upload-view_info_icon'>
          <Icon
            className='integration-upload-view_channel-icon'
            name={`channel-custom_upload`}
            size='77px'
          />
        </div>
        {this.renderButton()}
      </div>
    )
  }

  renderButton() {
    const {closeModal} = this.props

    return (
      <Link
        to={`/settings/integrations/upload`}
        className='integration-upload-view_info_action button is-blue'
        onClick={() => closeModal()}
      >
        Add
      </Link>
    )
  }

  renderHeader() {
    return (
      <div className='integration-upload-view_header'>
        <div className='integration-upload-view_title'>Manual input</div>
        <div className='integration-upload-view_description'>Add cost data manually to any channel</div>
      </div>
    )
  }

  renderContent() {
    return (
      <div className='integration-upload-view_main-content'>
        <p>
          A manual input allows you to add cost data to any of your channels, by uploading an Excel sheet.
        </p>
        <h2>
          Integrations details
        </h2>
        <p>
          Get going in a few steps:
        </p>
        <ol>
          <li>Click the Add button to the left</li>
          <li>Choose the channel you want to add cost data for</li>
          <li>
            Upload your file (only *.xlsx for now).
            <strong> It is important that the first row of the sheet contains headlines
              and that the data starts on the second row.
            </strong>
            <strong>The column needs to include date and cost data per day.</strong>
          </li>
        </ol>
      </div>
    )
  }
}

const mapDispatchToProps = {
  closeModal
}

export default connect(null, mapDispatchToProps)(IntegrationUploadView)



// WEBPACK FOOTER //
// ./client/modals/IntegrationUploadView/index.js